import { useCallback, useRef, useState } from 'react';
import { toast } from 'sonner';

/**
 * Blocks repeat submissions while one is in flight.
 * The ref check is synchronous, so queued clicks are rejected even if React
 * has not re-rendered the disabled button yet (slow network / busy main thread).
 */
export function useSubmitGuard(waitMessage = 'Please wait — your last entry is still being saved') {
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);

  const run = useCallback(async (fn) => {
    if (busyRef.current) {
      if (waitMessage) toast.info(waitMessage);
      return undefined;
    }
    busyRef.current = true;
    setBusy(true);
    try {
      return await fn();
    } finally {
      busyRef.current = false;
      setBusy(false);
    }
  }, [waitMessage]);

  return { busy, run };
}
